import registry from "./registry"

export default (name, func) => registry[name]().then(func)
